import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'fa' || 'md' || 'mdi'
    },
    theme: {
        dark: true,
        themes: {
            dark: {
                background: '#0b0b0b',
                surface: '#121212',
                primary: '#8ab4f8',
                secondary: '#03dac6',
                accent: '#ffb74d',
                info: '#64b5f6',
                success: '#81c784',
                warning: '#ffca28',
                error: '#ef5350'
            }
        }
    }
});